module.exports = fetch.bind();
